<template>
  <v-container>
    <material-card>
      <v-layout px-3 slot="header">
        <v-flex my-4 pl-4 title align-center justify-center>Pracownicy</v-flex>

        <v-spacer />

        <v-flex>
          <v-text-field
            prepend-icon="mdi-magnify"
            name="search"
            label="Wyszukaj"
            color="white"
            clearable
            v-model="search"
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <router-link v-if="isOfficial" :to="{ name: 'partner', params: { id: partnerId } }">
            <v-btn small color="primary"> <v-icon>mdi-undo</v-icon>Profil Partnera </v-btn>
          </router-link>
        </v-flex>

        <v-flex text-xs-right>
          <check-permission permissions="PARTNER.EMPLOYEE_ADD" entityType="partner" :entityId="partnerId">
            <v-btn large color="error" @click="showAddModal">DODAJ PRACOWNIKA</v-btn>
          </check-permission>
        </v-flex>
      </v-layout>

      <material-table
        linkField="userId"
        editField="userId"
        entityType="profile"
        :roleLinkField="roleLinkField"
        :roleLinkParam="roleLinkParam"
        :roleAddAction="true"
        :headers="table.headers"
        :items="list"
        :actions="true"
        :hideActions="false"
        :total-count="count"
        :search="search"
        :editPerm="['PROFILE.UPDATE']"
        :deletePerm="['PROFILE.DELETE']"
        @pagination="reloadList"
        @add="showAddModal"
        @edit="showEditModal"
        @delete="showDeleteDialog"
      />

      <material-dialog
        title="Potwierdź usunięcie"
        :show="!!idToDelete"
        :id="idToDelete"
        :text="confirmDeleteText"
        @close="hideDeleteDialog"
        @confirm="remove"
      />
    </material-card>

    <modal :show="showModal" :id="idToEdit" :edit="!!idToEdit" @close="hideModal" @save="add" @update="update" />
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import { SessionStorage, isOfficial } from '@witkac/kartamiejska-shared';

import MaterialCard from '@/components/material/Card';
import MaterialDialog from '@/components/material/Dialog';
import MaterialTable from '@/components/material/Table';
import Modal from './modals/Employee.modal';
import store from '@/store/store';
import { listMixin } from '@/mixins/list';

// @vuese
// Wyświetlanie listy pracowników danego partnera
// @group Partner
export default {
  mixins: [
    listMixin('employees', {
      listError: 'Wystąpił błąd podczas pobierania listy pracowników.',
      getError: 'Wystąpił błąd podczas pobierania danych pracownika.',
      added: 'Dodano pracownika.',
      addError: 'Nie udało się dodać pracownika.',
      updated: 'Zaktualizowano dane pracownika.',
      updateError: 'Nie udało się zaktualizować danych pracownika.',
      deleted: 'Usunięto pracownika.',
      deleteError: 'Nie udało się usunąć pracownika.'
    })
  ],
  components: {
    MaterialCard,
    MaterialDialog,
    MaterialTable,
    Modal
  },
  data() {
    return {
      search: '',
      table: {
        headers: [
          { value: 'email', text: 'Adres e-mail', sortable: false, link: true },
          { value: 'firstName', text: 'Imię', sortable: false },
          { value: 'lastName', text: 'Nazwisko', sortable: false }
        ]
      },
      idToEdit: undefined,
      showModal: false
    };
  },
  computed: {
    ...mapState({ partnerId: state => state.partners.id }),
    toDelete() {
      if (this.idToDelete) {
        return this.list.find(item => item.id === this.idToDelete);
      }
    },
    confirmDeleteText() {
      if (this.toDelete) {
        return `Czy napewno chcesz usunąć konto pracownika ${this.toDelete.firstName} ${this.toDelete.lastName}?`;
      }
      return '';
    },
    isOfficial,
    roleLinkField() {
      return isOfficial() ? 'employeeOfficialRoles' : 'employeePartnerRoles';
    },
    roleLinkParam() {
      return isOfficial() ? 'employeeId' : 'id';
    }
  }
};
</script>
